import { createTheme } from "@mui/material/styles";

const themeConfig = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: "#2563eb",
      light: "#60a5fa",
      dark: "#1d4ed8",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#64748b",
      light: "#94a3b8",
      dark: "#475569",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f8fafc",
      paper: "#ffffff",
      secondary: "#f1f5f9",
      tertiary: "#e2e8f0",
    },
    text: {
      primary: "#0f172a",
      secondary: "#475569",
      disabled: "#94a3b8",
    },
    grey: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
    },
    success: {
      main: "#10b981",
      light: "#34d399",
      dark: "#059669",
    },
    warning: {
      main: "#f59e0b",
      light: "#fbbf24",
      dark: "#d97706",
    },
    error: {
      main: "#ef4444",
      light: "#f87171",
      dark: "#dc2626",
    },
    info: {
      main: "#3b82f6",
      light: "#60a5fa",
      dark: "#2563eb",
    },
    divider: "#e2e8f0",
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
      color: "#0f172a",
      letterSpacing: "-0.02em",
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 700,
      color: "#0f172a",
      letterSpacing: "-0.015em",
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
      color: "#0f172a",
      letterSpacing: "-0.01em",
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
      color: "#0f172a",
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 600,
      color: "#0f172a",
    },
    h6: {
      fontSize: "1.125rem",
      fontWeight: 600,
      color: "#1e293b",
    },
    body1: {
      fontSize: "1rem",
      color: "#475569",
    },
    body2: {
      fontSize: "0.875rem",
      color: "#475569",
    },
    caption: {
      fontSize: "0.75rem",
      color: "#94a3b8",
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 6,
  },
  shadows: [
    "none",
    "0 1px 2px 0 rgba(15, 23, 42, 0.05)",
    "0 1px 3px 0 rgba(15, 23, 42, 0.08), 0 1px 2px -1px rgba(15, 23, 42, 0.04)",
    "0 4px 6px -1px rgba(15, 23, 42, 0.07), 0 2px 4px -2px rgba(15, 23, 42, 0.04)",
    "0 10px 15px -3px rgba(15, 23, 42, 0.07), 0 4px 6px -4px rgba(15, 23, 42, 0.04)",
    "0 20px 25px -5px rgba(15, 23, 42, 0.08), 0 8px 10px -6px rgba(15, 23, 42, 0.04)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#f8fafc",
          fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
          ].join(","),
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          color: "#0f172a",
          boxShadow: "0 1px 2px 0 rgba(15, 23, 42, 0.05)",
          borderBottom: "1px solid #e2e8f0",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow:
            "0 1px 3px 0 rgba(15, 23, 42, 0.06), 0 1px 2px -1px rgba(15, 23, 42, 0.04)",
          border: "1px solid #e2e8f0",
          borderRadius: 6,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 6,
          fontWeight: 500,
          boxShadow: "none",
          "&:hover": {
            boxShadow:
              "0 1px 3px 0 rgba(15, 23, 42, 0.06), 0 1px 2px -1px rgba(15, 23, 42, 0.04)",
          },
        },
        contained: {
          boxShadow:
            "0 1px 2px 0 rgba(15, 23, 42, 0.05)",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 6,
            backgroundColor: "#ffffff",
            "& fieldset": {
              borderColor: "#e2e8f0",
            },
            "&:hover fieldset": {
              borderColor: "#cbd5e1",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#2563eb",
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          boxShadow:
            "0 1px 3px 0 rgba(15, 23, 42, 0.06), 0 1px 2px -1px rgba(15, 23, 42, 0.04)",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#f8fafc",
          "& .MuiTableCell-head": {
            fontWeight: 600,
            color: "#0f172a",
            borderBottom: "1px solid #e2e8f0",
            fontSize: "0.8rem",
            letterSpacing: "0.01em",
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#f8fafc",
          },
          "&.Mui-selected": {
            backgroundColor: "#eff6ff",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #f1f5f9",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontWeight: 500,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#ffffff",
          borderRight: "1px solid #e2e8f0",
          boxShadow:
            "4px 0 12px rgba(15, 23, 42, 0.04)",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          margin: "2px 8px",
          "&:hover": {
            backgroundColor: "#f1f5f9",
          },
          "&.Mui-selected": {
            backgroundColor: "#eff6ff",
            "&:hover": {
              backgroundColor: "#dbeafe",
            },
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
          boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.25)",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 4,
          fontSize: "0.75rem",
          fontWeight: 500,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
          fontSize: "0.875rem",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
      },
    },
  },
});

export default themeConfig;
